import { useQuery } from "@tanstack/react-query";
import { useAuth, useOrganization } from "@clerk/clerk-react";
import { ICall } from "../types/call";
import { useApi } from "../services/api/api-service";
import { useActiveAgent } from "../contexts/ActiveAgentContext";
import { filterValidCalls } from "../utils/call-helpers";

const LIMIT = 4;

export function useRecentCalls() {
  const { getToken } = useAuth();
  const { organization: activeOrg } = useOrganization();
  const { activeAgent, agentsLoading: isLoadingAgent } = useActiveAgent();
  const agentRequired = true;
  const homeApi = useApi(agentRequired);

  return useQuery<ICall[]>({
    queryKey: ["recent-calls", activeOrg?.id, activeAgent?.id],
    queryFn: async () => {
      const response = await homeApi.get<{
        calls: ICall[];
        nextCursor: string | null;
      }>(`/calls?pageSize=${LIMIT}`);
      return filterValidCalls(response.calls);
    },
    retry: false,
    enabled:
      !isLoadingAgent &&
      !!getToken() &&
      !!activeOrg &&
      !!activeOrg.id &&
      !!activeAgent?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes - keep in cache for 15 minutes
    refetchOnWindowFocus: false,
  });
}
